import { string, shape, bool, array, arrayOf, object } from "prop-types";
import { useEffect, useRef } from "react";
import Hls from "hls.js";

export const Video = ({ data }) => {
  const videoRef = useRef(null);
  const url = data.videoSrc.asset.url;

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.controls = true;
    let hls;

    if (Hls.isSupported()) {
      // Prefer hls.js wherever MSE is available. Chrome 152+ reports "maybe"
      // for native HLS via canPlayType but then fails to play Mux streams
      // (MEDIA_ERR_SRC_NOT_SUPPORTED), so native playback is the fallback only.
      hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari (especially iOS) has no MSE but supports HLS natively
      video.src = url;
    } else {
      console.error(
        "This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API"
      );
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [url, videoRef]);

  return (
    <video
      ref={videoRef}
      preload="metadata"
      controlsList="nodownload nofullscreen noremoteplayback"
      muted
      playsInline
      autoPlay
      loop
    />
  );
};

Video.propTypes = {
  _key: string,
  _type: string,
  isSmall: bool,
  videoSrc: shape({
    asset: shape({
      _createdAt: string,
      _id: string,
      _rev: string,
      _type: string,
      _updatedAt: string,
      assetId: string,
      playbackId: string,
      status: string,
      uploadId: string,
      url: string,
      data: object,
    }),
  }),
  text: shape({
    _type: string,
    content: arrayOf(
      shape({
        _key: string,
        _type: string,
        style: string,
        children: arrayOf(
          shape({
            _key: string,
            _type: string,
            marks: array,
            text: string,
          })
        ),
        markDefs: array,
      })
    ),
  }),
};
